/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatURLFacebookShare, formatURLMailto } from 'helpers/strings';
import { Button } from '@companycam/slab-web';
import CCClipboard from 'components/shared/CCClipboard';

const Share = ({ galleryId, onSuccess, copied, isSingleVideoGallery }) => {
  const galleryUrl = `${document.location.origin}/${
    isSingleVideoGallery ? 'share/video' : 'galleries'
  }/${galleryId}`;
  return (
    <form>
      <div className="link-copy-box-container" data-testid="share-modal__link-section">
        <div className="link-copy-box">{galleryUrl}</div>
        <CCClipboard copy={galleryUrl} onCopy={onSuccess}>
          <i className="mdi mdi-link-variant" />
          {copied ? (
            <FormattedMessage id="Common.share.copied!" />
          ) : (
            <FormattedMessage id="Common.share.copyLink" />
          )}
        </CCClipboard>
      </div>

      <div className="btn-container full">
        <Button
          color="primary"
          icon={{
            name: "open-in-new",
            position: "before",
          }}
          href={galleryUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="share-modal__button-view-gallery"
        >
          {isSingleVideoGallery ? (
            <FormattedMessage
              id="Galleries.share.video.viewGallery"
              defaultMessage="View Video"
              description="Button that allows the user to view the video"
            />
          ) : (
            <FormattedMessage
              id="Galleries.share.viewGallery"
              defaultMessage="View Gallery"
              description="Button that allows the user to view the gallery"
            />
          )}
        </Button>
        <Button
          icon={{
            name: "facebook",
            position: "before",
          }}
          href={formatURLFacebookShare({
            url: galleryUrl,
            title: isSingleVideoGallery
              ? 'CompanyCam Video'
              : 'CompanyCam Photo Gallery',
          })}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="share-modal__button-facebook"
        >
          Facebook
        </Button>
        <Button
          icon={{
            name: "email-outline",
            position: "before",
          }}
          href={formatURLMailto({
            subject: isSingleVideoGallery
              ? 'Video - CompanyCam'
              : 'Photo Gallery - CompanyCam',
            bodyLines: [
              isSingleVideoGallery
                ? 'Hey, I created a video for you with CompanyCam. Just click the link below to view the video!'
                : 'Hey, I created a photo gallery for you with CompanyCam. Just click the link below to view the photos!',
              '',
              galleryUrl,
            ],
          })}
          data-testid="share-modal__button-email"
        >
          <FormattedMessage id="Common.share.email" />
        </Button>
      </div>
    </form>
  );
};

export default Share;
